<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-end">
                <div class="col-sm mb-2 mb-sm-0">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-no-gutter">
                            <li class="breadcrumb-item"><router-link class="breadcrumb-link" to="/">Kokpit</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Klienci</li>
                        </ol>
                    </nav>
                    <h1 class="page-header-title">Klienci API</h1>
                </div>
            </div>
        </div>
        <!-- End Page Header -->

        <div class="card shadow-sm border-0">
            <div class="card-header border-bottom-0">
                <div class="row justify-content-between align-items-center flex-grow-1">
                    <div class="col-md">
                        <h4 class="card-header-title">Lista aktywnych klientów</h4>
                    </div>
                    <div class="col-auto">
                        <!-- Placeholder for search/filter if needed -->
                    </div>
                </div>
            </div>

            <div class="table-responsive">
                <table
                    class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table">
                    <thead class="thead-light">
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th>Identyfikator klienta</th>
                            <th>Klucz (Secret)</th>
                            <th>Miesiąc bieżący</th>
                            <th>Miesiąc poprzedni</th>
                            <th>Suma ogółem</th>
                            <th class="text-end">Opcje</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in items" :key="item.client_id">
                            <td>{{ index + 1 }}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="avatar avatar-sm avatar-soft-primary avatar-circle me-3">
                                        <span class="avatar-initials text-uppercase">{{ item.client_id.charAt(0)
                                            }}</span>
                                    </div>
                                    <span class="h5 mb-0 text-inherit">{{ item.client_id }}</span>
                                </div>
                            </td>
                            <td>
                                <code
                                    class="text-secondary">{{ isAdmin ? item.client_secret : $maskPassword(item.client_secret) }}</code>
                            </td>
                            <td>
                                <span class="badge bg-soft-info text-info rounded-pill">
                                    <i class="bi-chat-left-text me-1"></i> {{ item.sms.sms_count_current_month }}
                                </span>
                            </td>
                            <td>
                                <span class="text-body">{{ item.sms.sms_count_last_month }}</span>
                            </td>
                            <td>
                                <span class="fw-bold">{{ item.sms.sms_count_all }}</span>
                            </td>
                            <td class="text-end">
                                <router-link :to="'/client/' + item.client_id + '/sms'" class="btn btn-white btn-sm"
                                    v-tooltip="'Zobacz wiadomości'">
                                    <i class="bi-eye me-1"></i> Wiadomości
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="items.length === 0" class="card-body text-center py-5">
                <i class="bi-people display-1 text-muted opacity-25"></i>
                <p class="mt-3">Brak zarejestrowanych klientów API.</p>
            </div>
        </div>
    </div>
</template>

<script>
import panelApi from '../../api/panel-axios.js';
import appConfig from '../../config.js';

export default {
    name: 'ClientIndex',
    data() {
        return {
            items: [],
            loading: false
        }
    },
    computed: {
        isAdmin: function () {
            return ['owner', 'manager'].includes(this.$store.getters['app/role'])
        }
    },
    methods: {
        load() {
            this.loading = true;
            panelApi.get(appConfig.panelApiPrefix + '/sms/client').then(response => {
                this.items = response.data.clients || [];
                this.loading = false;
            }).catch(err => {
                console.error(err);
                this.loading = false;
            });
        }
    },
    mounted() {
        this.load();
    }
}
</script>

<style scoped>
.avatar-soft-primary {
    background-color: rgba(55, 125, 255, 0.1);
    color: #377dff;
    width: 2.2rem;
    height: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
}

.bg-soft-info {
    background-color: rgba(0, 200, 255, 0.1) !important;
}

.card-table .btn-white {
    border-color: #e7eaf3;
}

.card-table .btn-white:hover {
    background-color: #f8fafd;
}
</style>